import ImageCropPicker, { ImageOrVideo } from 'react-native-image-crop-picker';
import { setAppOpenAdPaused } from './useOpenAppAd';


type MediaType='photo' | 'video'

interface SelectImageOptions {
    multiple?: boolean;
    cb?: (file: ImageOrVideo) => void;  // Update cb to accept a file parameter
    editor?: boolean;
    compress?: number;
    type?: MediaType;
}


export const selectImage = async (options: SelectImageOptions): Promise<ImageOrVideo> => {
    try {
        setAppOpenAdPaused(true);
        const file = await ImageCropPicker.openPicker({
            width: 300,
            height: 400,
            cropping: options.editor,
            multiple: options.multiple,
            compressImageQuality: options.compress,
            mediaType: options.type || 'photo',
        });
        if (options.cb) {
            options.cb(file);
        }
        return file;
    } finally {
        setAppOpenAdPaused(false, 1000);
    }
};


export const onOpenCamear = async (options: SelectImageOptions): Promise<ImageOrVideo> => {
    try {
        setAppOpenAdPaused(true);
        const file = await ImageCropPicker.openCamera({
            width: 300,
            height: 400,
            cropping: options.editor,
            multiple: options.multiple,
            compressImageQuality: options.compress,
            mediaType: options.type || 'photo',
        });
        if (options.cb) {
            options.cb(file);
        }
        return file;
    } finally {
        setAppOpenAdPaused(false, 1000);
    }
};

